import React from 'react'
import { Control } from 'react-redux-form'
import Switch from 'react-switch'

class SwitchControl extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { model, createFromValue, style, className, children, ...rest } = this.props

    //console.log("DATE", rest)
    return (
      <Control.custom
        model={model}
        component={Switch}
        className={className}
        mapProps={{
          onChange: props => v => {
            console.log('SET', props, v)
            props.onChange(v)
          },
          checked: props => {
            console.log('GET', props)

            return props.viewValue
          }
        }}
        {...rest}>
        {children}
      </Control.custom>
    )
  }
}

export default SwitchControl
